<template>
  <div class="service">
    <div class="termination__row">
      <div class="form__field">
        <VSelect class="select select--default select--shadow" :class="{ 'select--error': service.companyHasError }"
          :options="companies" :reduce="(company) => company.id" label="name" :placeholder="$t(`addTerminationModal.${'company'}`)"
          v-model="terminationService.companyId" />

        <div class="form__error" v-if="service.companyHasError">
          {{ $t(`addTerminationModal.${'companyMsg'}`) }}
        </div>
      </div>
      <div class="form__field">
        <div v-if="!services.length" class="select select--default select--readonly"
          :class="{ 'select--error': service.serviceHasError }">
          {{ $t(`addTerminationModal.${'services'}`) }}
        </div>
        <VSelect v-else :reduce="(service) => service.id" class="select select--default select--shadow"
          :class="{ 'select--error': service.serviceHasError }" :options="services" :label="`name`"
          :placeholder="$t(`addTerminationModal.${'services'}`)"
          v-model="terminationService.serviceId" />

        <div class="form__error" v-if="service.serviceHasError">
          {{ $t(`addTerminationModal.${'servicesMsg'}`) }}
        </div>
      </div>
      <div class="form__field">
        <Datepicker class="input input--default input--shadow" :placeholder="$t(`addTerminationModal.${'termination'}`)"
          :class="{ 'select--error': service.dateHasError }" :config="statics.datePickerConfig"
          v-model="terminationService.terminationDate" />
        <div class="form__error" v-if="service.dateHasError">
          {{ $t(`addTerminationModal.${'terminationMsg'}`) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch,   } from "vue";
import { useStore } from "vuex";
import statics from "@/statics";
//import { formatDisplayDate } from "@/helpers/dateFormatters";

const store = useStore();

const {service, companies, index, updateSpecificTerminationServiceField} = defineProps({
  service: {
    required: true,
    type: Object,
  },
  companies: {
    required: true,
    type: Array,
  },
  index: {
    required: true,
    type: Number,
  },
  updateSpecificTerminationServiceField: {
    required: true,
    type: Function,
  },
});

// State
const services = ref([]);
const terminationService = ref({
  companyId: "",
  terminationDate: "",
  serviceId: "",
});

// Computed 

// Watcher
watch(
  () => terminationService.value.companyId,
  async (companyId) => {
    try {
      if (companyId) {
        services.value = await store.dispatch("getCompanyServices", companyId);
      }
    } catch (err) {
      console.error(err);
    }
  }
);

watch(
  () => terminationService.value.terminationDate,
  (date) => {
    updateSpecificTerminationServiceField(index, 'terminationDate', date);
  }
);

watch(
  () => terminationService.value.serviceId,
  (serviceId) => {
    updateSpecificTerminationServiceField(index, 'serviceId', serviceId);
  }
);

watch(
  () => terminationService.value.companyId,
  (companyId) => {
    updateSpecificTerminationServiceField(index, 'companyId', companyId);
  }
);
</script> 

<style lang="scss" scoped>
.form__field {
  flex: 1;
  margin: 20px 10px 20px 0;

  &:last-child {
    margin-right: 0;
  }
}
</style>
